export default __webpack_public_path__ + "static/media/2.81f5f9f7.webp";